import { useCallback } from 'react'
import { useRequiredContext } from 'legacy/contexts/utils'
import { NotificationsContext } from 'legacy/contexts/notifications/NotificationsContext'
import { type PartnerPickRecurringShiftsRecurringShift } from 'domains/partner-pick-devices/api'
import { useDashIntl } from 'intl/intl.hooks'

export const usePartnerPickRecurringShiftsNotificationsHooks = () => {
  const { notify: _notify } = useRequiredContext(NotificationsContext)
  const intl = useDashIntl()

  const notify = useCallback(
    (shift: PartnerPickRecurringShiftsRecurringShift, messageId?: any) => { // eslint-disable-line
      const message = intl.formatMessage({
        id: messageId ? messageId : 'shiftsDomain.notifications.recurring.created',
      })

      _notify(message, 'modern')
    },
    [_notify, intl]
  )

  return {
    notify,
  }
}
